// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2Iilh","col":"CardReaderDesc_col__3X191","label":"CardReaderDesc_label__2AjLu"};